import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core'

import { ColorPaper } from '../Atoms'

const useStyles = makeStyles(theme => ({
    paper: {
        '& .MuiDialog-paper': {
            borderColor: theme.palette.primary.main,
            borderWidth: 5,
            borderStyle: 'solid',
        }
    },
    paragraph: {
        marginBottom: 10,
    }
}))

const MainDisclaimer = ({ open, onAccept }) => {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
        <Dialog
            className={classes.paper}
            PaperComponent={ColorPaper}
            open={open}
            maxWidth="md"
        >
            <DialogTitle>{t('disclaimer.title')}</DialogTitle>
            <DialogContent>
                {t('disclaimer.main', { returnObjects: true }).map((paragraph, index) => (
                    <DialogContentText className={classes.paragraph} key={index}>
                        {paragraph}
                    </DialogContentText>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => window.location = "https://www.google.com"} color="primary" variant="outlined">
                    {t('disclaimer.decline')}
                </Button>
                <Button onClick={() => onAccept()} color="primary" variant="contained">
                    {t('disclaimer.accept')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default MainDisclaimer